<template>
  <form
    class="form form--vertical"
    novalidate
    @submit="submit"
  >
    <slot/>
  </form>
</template>

<script setup>
  import { computed, provide } from 'vue';

  const emit = defineEmits(['submit']);

  const props = defineProps({
    errors: {
      type: Object,
      default: null,
    },
  });

  const formOptions = computed(() => {
    return {
      formOptions: {
        fieldErrors: props.errors,
      },
    };
  });

  provide('formOptions', formOptions.value);

  function submit(event) {
    event.preventDefault();
    emit('submit');
  }
</script>
